import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useLazyQuery } from '@apollo/react-hooks';
import { SimilarAudiences, SimilarAudiencesVariables } from './__generated__/SimilarAudiences';

export const SIMILAR_AUDIENCES_QUERY = gql`
  query SimilarAudiences($articleId: ID!) {
    similarAudiences(articleId: $articleId) {
      result {
        fromPublisher
        fromOthers
      }
      errors
    }
  }
`;

export const useSimilarAudiencesQuery = () => {
  return useLazyQuery<SimilarAudiences, SimilarAudiencesVariables>(SIMILAR_AUDIENCES_QUERY, {
    client: kmsClient,
    fetchPolicy: 'cache-first'
  });
};
